import * as React from "react";
function SvgIcChevronSmallRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 16.5l2.634-4.563L10 7.375 10.649 7l2.851 4.937-2.851 4.938L10 16.5z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcChevronSmallRight;
